module.exports = __webpack_public_path__ + "static/media/w (37).75919446.jpg";